import { PositionType } from "../../../entities/position";
import PositionRepository from "../../ports/positionRepository";

export type updatePositionUsecase = (
  id: string,
  data: Partial<PositionType>
) => Promise<Partial<PositionType>>;

export const buildUpdatePosition = (dependencies: {
  positionRepo: PositionRepository;
}): updatePositionUsecase => {
  const { positionRepo } = dependencies;

  const updatePosition: updatePositionUsecase = async (
    id: string,
    data: Partial<PositionType>
  ) => positionRepo.updatePosition(id, data);

  return updatePosition;
};
